import {styles} from "./style";

export function loaderStyle() {
  const cb = document.getElementById("chart_blocks");
  if(cb) cb.remove();
  const s = document.createElement("style");
  s.setAttribute("id", "chart_blocks");
  s.textContent  = cssOf(styles);
  document.head.appendChild(s);
}

function cssOf(json) {
  const selectors = Object.keys(json)
  return selectors.map((selector) => {
    const definition = json[selector]
    const rules = Object.keys(definition)
    const result = rules.map((rule) => {
      return `${rule}:${definition[rule]}`
    }).join(';')
    return `${selector}{${result}}`
  }).join('\n')
}



// WEBPACK FOOTER //
// ./src/app/modules/chartBlocks/file-loader.ts